import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { withBackgroundRefreshHeader } from "../features/dashboard/services/background-refresh-scope";

/**
 * Pose `X-Background-Refresh: 1` sur les requêtes vers back-metier émises
 * pendant un rafraîchissement AUTOMATIQUE du tableau de bord (portée
 * `BackgroundRefreshScope` : 5 s au plus, refermée au premier geste). back-metier
 * ne compte pas de user-jour pour elles.
 *
 * ⚠️ Posé ICI, et pas sur chaque appel : le tick déclenche une dizaine de
 * chemins de chargement (widget générique, widgets qui chargent eux-mêmes
 * leurs données, API des non-conformités). Au niveau HTTP, un nouveau widget en
 * hérite sans rien faire — appel par appel, il l'oublierait, et un seul GET
 * non marqué suffit à compter la journée.
 */
@Injectable()
export class BackgroundRefreshInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const headers = withBackgroundRefreshHeader(req.url, req.headers);
    return next.handle(headers === req.headers ? req : req.clone({ headers }));
  }
}
